'use strict';

var sdkData = require('../../config/sdks.json');

function getAllSdkNames() {
  var serverNames = Object.keys(sdkData.server);
  var clientNames = Object.keys(sdkData.client);

  return serverNames.concat(clientNames);
}

function getServerSdkNames() {
  return Object.keys(sdkData.server);
}

function getSdk(sdk) {
  return sdkData.server[sdk] || sdkData.client[sdk];
}

function getCurrentVersion(sdk) {
  var sdkInfo = sdkData.server[sdk] || sdkData.client[sdk];

  if (sdkInfo.defaultVersion) {
    return sdkInfo.defaultVersion;
  }

  if (sdkInfo.versions) {
    return sdkInfo.versions[sdkInfo.versions.length - 1];
  }

  return null;
}

function getCurrentClientSdkIds() {
  var version;
  var clientSdkInfo = sdkData.client;

  return Object.keys(clientSdkInfo).map(function (sdkKey) {
    version = clientSdkInfo[sdkKey].defaultVersion ? clientSdkInfo[sdkKey].defaultVersion : clientSdkInfo[sdkKey].versions.slice(-1);

    return '/' + sdkKey + '/v' + version;
  });
}

function getDefaultClientSdk() {
  return sdkData.defaults.client;
}

function getDefaultServerSdk() {
  return sdkData.defaults.server;
}

function isValidSdk(sdk) {
  return isValidClientSdk(sdk) || isValidServerSdk(sdk);
}

function isValidClientSdk(sdk) {
  return sdk in sdkData.client;
}

function isValidServerSdk(sdk) {
  return sdk in sdkData.server;
}

function isValidLanguage(sdk, lang) {
  var languages;

  if (isValidClientSdk(sdk)) {
    languages = sdkData.client[sdk].languages;
  } else {
    languages = sdkData.server[sdk].languages;
  }

  return languages.indexOf(lang) !== -1;
}

module.exports = {
  getAllSdkNames: getAllSdkNames,
  getServerSdkNames: getServerSdkNames,
  getCurrentVersion: getCurrentVersion,
  getCurrentClientSdkIds: getCurrentClientSdkIds,
  getDefaultClientSdk: getDefaultClientSdk,
  getDefaultServerSdk: getDefaultServerSdk,
  getSdk: getSdk,
  isValidSdk: isValidSdk,
  isValidClientSdk: isValidClientSdk,
  isValidServerSdk: isValidServerSdk,
  isValidLanguage: isValidLanguage
};
